import { BillingClient, SignupState } from "../../types/EmbeddedSignupType";

export const MOCK_STATES: Record<string, SignupState> = {
    NOT_CONNECTED: { status: "NOT_CONNECTED" },
    CHOOSE_NUMBER: {
        status: "CHOOSE_NUMBER", step: 3, wabaName: "Acme Retail",
        phoneNumbers: [
            { id: "1", displayPhoneNumber: "+91 98765 43210", verifiedName: "Acme Retail" },
            { id: "2", displayPhoneNumber: "+91 91234 56789", verifiedName: "Acme Retail Support" },
        ],
    },
    PIN_NEEDED: {
        status: "PIN_NEEDED", step: 6, wabaName: "Acme Retail",
        displayPhoneNumber: "+91 91234 56789", billing: "EMPEDANCE",
        lastError: "This number already has a two-step verification PIN. Enter it to continue.",
    },
    NEEDS_ATTENTION: {
        status: "NEEDS_ATTENTION", step: 6, wabaName: "Acme Retail",
        displayPhoneNumber: "+91 98765 43210", billing: "EMPEDANCE",
        lastError: "Too many attempts to register this number. Wait a few hours and click Retry.",
    },
    CONNECTED: {
        status: "CONNECTED", wabaName: "Acme Retail", verifiedName: "Acme Retail",
        displayPhoneNumber: "+91 98765 43210", billing: "EMPEDANCE",
        qualityRating: "GREEN", messagingLimit: "TIER_1K", nameStatus: "APPROVED",
        accountReviewStatus: "APPROVED", businessVerification: "not_verified", testMessageSent: true,
    },
};

export const MOCK_CLIENTS: BillingClient[] = [
    { userId: 41, businessName: "City Clinic", connected: true, phoneNumber: "+91 99887 76655", wabaId: "102938475610", onCreditLine: true, creditSharedAt: "2026-09-22" },
    { userId: 57, businessName: "Spice Garden", connected: true, phoneNumber: "+91 90909 12121", wabaId: "102938475611", onCreditLine: false, billingError: "Empedance's system user can't manage billing yet." },
    { userId: 72, businessName: "Acme Retail", connected: true, phoneNumber: "+91 98765 43210", wabaId: "102938475613", onCreditLine: true, creditSharedAt: "2026-10-01" },
    { userId: 63, businessName: "FitZone Gym", connected: false, phoneNumber: "+91 93333 44444", wabaId: "102938475612", onCreditLine: false },
];